export const extractErrMsg = (err: any) => {
  return err.response?.data?.message ? err.response.data.message : err.message;
};
